import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  sendPasswordResetEmail,
  Auth,
} from 'firebase/auth';
import { AppUser } from '@/types';
import { firebaseConfig } from '../firebase/firebaseConfig';

function getClientApp() {
  if (getApps().length > 0) {
    return getApp();
  }
  return initializeApp(firebaseConfig);
}

export function getClientAuth(): Auth {
  const app = getClientApp();
  return getAuth(app);
}

export async function signInWithGooglePopup(): Promise<{ email: string; displayName: string; idToken: string }> {
  const auth = getClientAuth();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  const result = await signInWithPopup(auth, provider);
  const user = result.user;
  const idToken = await user.getIdToken();
  return {
    email: user.email || '',
    displayName: user.displayName || user.email?.split('@')[0] || 'Usuario',
    idToken,
  };
}

export async function sendClientPasswordReset(email: string): Promise<void> {
  const auth = getClientAuth();
  await sendPasswordResetEmail(auth, email.trim().toLowerCase());
}

export async function loginWithApi(email: string, password: string): Promise<AppUser> {
  const res = await fetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Credenciales inválidas');
  return data.user;
}

export async function registerWithApi(email: string, password?: string, displayName?: string): Promise<AppUser> {
  const res = await fetch('/api/auth/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, displayName }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Error al registrar usuario');
  return data.user;
}

